const agoraConfig = {
    APP_ID: "0add0da6f21f4abfaf8af383fd6c51c6",
}// Replace with your Agora App ID


export default agoraConfig